<template>
  <ContentGroup>
    <BlockGroup inline>
      <Block
        label="คำนำหน้า"
        no-border
      >
        <SelectBox
          label="คำนำหน้า"
          prop="prefixId"
          :edata="data.newProfile['prefixId']"
          :required="!data.warning['prefixId']"
          @input="methods.inputHandler"
          :options="prefixOptions"
        />
      </Block>

      <Block
        label="รหัสอาจารย์"
        no-border
      >
        <InputBox
          label="รหัสอาจารย์"
          prop="code"
          :edata="data.newProfile['code']"
          :required="!data.warning['code']"
          @input="methods.inputHandler"
        />
      </Block>

    </BlockGroup>

    <BlockGroup inline>
      <Block
        label="ชื่อ"
        no-border
      >
        <InputBox
          label="ชื่อ"
          prop="firstNameLocal"
          :edata="data.newProfile['firstNameLocal']"
          :required="!data.warning['firstNameLocal']"
          @input="methods.inputHandler"
        />
      </Block>

      <Block
        label="นามสกุล"
        no-border
      >
        <InputBox
          label="นามสกุล"
          prop="lastNameLocal"
          :required="!data.warning['lastNameLocal']"
          :edata="data.newProfile['lastNameLocal']"
          @input="methods.inputHandler"
        />
      </Block>
    </BlockGroup>

    <BlockGroup inline>
      <Block
        label="First Name"
        no-border
      >
        <InputBox
          label="First Name"
          prop="firstNameEng"
          :edata="data.newProfile['firstNameEng']"
          @input="methods.inputHandler"
        />
      </Block>

      <Block
        label="Last Name"
        no-border
      >
        <InputBox
          label="Last Name"
          prop="lastNameEng"
          :edata="data.newProfile['lastNameEng']"
          @input="methods.inputHandler"
        />
      </Block>
    </BlockGroup>
  </ContentGroup>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import ContentGroup from "@/components/common-ui/content-group/index.vue";
import BlockGroup from "@/components/common-ui/block-group/index.vue";
import Block from "@/components/common-ui/block/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";
import data from "../data";

export default {
  components: {
    ContentGroup,
    BlockGroup,
    Block,
    InputBox,
    SelectBox
  },
  data() {
    return {
      ...data
    }
  },
  props: {
    methods: Object,
  },
  computed: {
    prefixOptions() {
      return this.$store.state.MasterData.prefixes;
    }
  },
}
</script>
